<template>
    <HomeLayout>
        <div
            class="md:tw-mt-[-30px] tw-my-3 tw-pl-6 tw-pr-6 md:tw-pl-14 md:tw-pr-14 tw-w-full tw-h-full tw-text-xl tw-font-[500]"
        >
            <SkeletonsParagraph :lines="15" height="25px" v-if="loading" />
            <template v-else>
                <h2 class="tw-font-[500] tw-border-b-2 tw-border-secondary">
                    {{ d.title }}
                </h2>
                <div class="tw-mt-3" v-html="d.content"></div>
            </template>
        </div>
    </HomeLayout>
</template>

<script setup lang="ts">
import HomeLayout from "~/layouts/HomeLayout.vue"
const router = useRouter()

const infoType = router.currentRoute.value.params.InformationPage

const { data, error, loading, get } = useOFetchCustom(`information/${infoType}`)

const d = computed(() => {
    return {
        title: data.value?.data.title,
        content: data.value?.data.content,
    }
})

useSeoMeta({ title: () => d.value.title ?? "Información" })

get()
</script>
